import { BasicRequest } from "./basicRequest";

export class ActionItemActionRequest extends BasicRequest{

    public id!:number;
    public actionTakenByUserId!:number;
    public typeOfActionTaken?:string;
    public remarkForActionTaken?:string;

    constructor(){
        super();
    }

}